<div *ngIf="errorMessage">
  <app-message severity="error" [noMargin]="true" data-cy="send-error-message">
    {{ errorMessage }}
  </app-message>
</div>
<div *ngIf="successMessage">
  <app-message severity="success" [noMargin]="true" data-cy="send-success-message">
    {{ successMessage }}
  </app-message>
</div>

<div *ngIf="userToken !== 'none'" class="flex flex-column align-items-center text-center" data-cy="page-error">
  <img src="./assets/icons/divisional-icons/bandaid-blue.svg" height="92px" class="mb-5" alt="Error Icon" />
  <h1 class="mt-0 mb-5 error-title">Oops, your activation link has expired</h1>
  <p class="p2 mt-0 mb-4 error-message">
    Your activation link expired after 30 days. Click below to receive a new activation email to activate your account.
  </p>
  <button
    pButton
    type="submit"
    label="Re-send Activation Email"
    class="w-full"
    (click)="resendEmail()"
    data-cy="submit-button"
    [disabled]="isDisabled"
  ></button>
</div>
<div *ngIf="userToken === 'none'" class="flex flex-column align-items-center text-center" data-cy="page-error">
  <img src="./assets/icons/divisional-icons/bandaid-blue.svg" height="92px" class="mb-5" alt="Error Icon" />
  <h1 class="mt-0 mb-5 error-title">Invalid Activation Link</h1>
  <p class="p2 mt-0 mb-4 error-message">
    Your activation link has expired or has been used. Please consider the options below.
  </p>
  <p class="p2 mb-0">
    Don't have an account?
    <a [routerLink]="['/login/new']" class="no-underline font-semibold">Sign Up</a>
  </p>
  <p class="p2 inline-link">Already have an account? <a class="inner-link" (click)="onBackToSignIn()">Sign In</a></p>
</div>
<app-mobile-footer></app-mobile-footer>
